module.exports = __webpack_public_path__ + "img/canistel-350x184.c6485022.jpg";